import React from "react";
// Layout
import AdminLayout from "../layout/AdminLayout";
// User Entry
import Login from "../pages/userEntryPage/Login";
// Dashboard
import Dashboard from "../pages/dashboard/Dashboard";
// Settings - Attributes
import Attributes from "../pages/settings/AttributeManagement/Attributes";
import AttributeSpecs from "../pages/settings/AttributeManagement/AttributeSpecs";
import AttributeValue from "../pages/settings/AttributeManagement/AttributeValue";
// Settings - Locality Management
import CountryMaster from "../pages/settings/LocalityManagement/Country";
import StateManagement from "../pages/settings/LocalityManagement/StateManagement";
import District from "../pages/settings/LocalityManagement/District";
import Taluk from "../pages/settings/LocalityManagement/Taluk";
import Village from "../pages/settings/LocalityManagement/Village";
import Area from "../pages/settings/LocalityManagement/Area"
import UserManagement from "../pages/settings/UserManagement/User";
import UserSubscription from "../pages/settings/UserManagement/UserSubscription";
// Settings - Property Management
import PropertyManagement from "../pages/PropertyManagement/Property";
import PropertyListingPage from "../pages/PropertyManagement/PostProperty";
import PropertyView from "../components/property/management/PropertyView";
import PropertyAnalytics from "../components/property/management/PropertyAnalytics";
import BannerManagement from "../pages/PropertyManagement/BannerManagement";
import { Routes, Route } from "react-router-dom";
import RequirePermission from "../utils/RequirePermission";
import { ROUTE_PERMISSIONS } from "../config/routePermissions";
// Setting - Subscription Management
import Subscription from "../pages/settings/SubscriptionManagement/Subscription";
import SubscriptionOffers from "../pages/settings/SubscriptionManagement/SubscriptionOffers";
// Settings - Report Management
import LocationReport from "../pages/settings/ReportManagement/LocationReport";
import VerificationReport from "../pages/settings/ReportManagement/VerificationReport";
import TransactionReports from "../pages/settings/ReportManagement/TransactionReport";
import TagsReport from "../pages/settings/ReportManagement/TagsReport";
import HelpRequestsTable from "../pages/settings/help desk/helpDesk";
import GstReport from "../pages/settings/ReportManagement/GstReport";
import InvoiceReport from "../pages/settings/ReportManagement/InvoiceReport";


export default function AppRoutes() {
  return (
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />
        
       
        <Route path="/" element={<AdminLayout />}>
          {/* Dashboard */}
            <Route index element={
                <RequirePermission permission={ROUTE_PERMISSIONS["dashboard"]}>
                    <Dashboard />
                </RequirePermission>
                } />
            <Route path="dashboard" element={
                <RequirePermission permission={ROUTE_PERMISSIONS["dashboard"]}>
                    <Dashboard />
                </RequirePermission>
                } />


        <Route path="settings/attributes"
            element={
            <RequirePermission permission={ROUTE_PERMISSIONS["settings/attributes"]}>
                <Attributes />
            </RequirePermission>
            }
        />

      <Route
        path="settings/attribute-specs"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/attribute-specs"]}>
            <AttributeSpecs />
          </RequirePermission>
        }
      />

      <Route
        path="settings/attribute-value"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/attribute-value"]}>
            <AttributeValue />
          </RequirePermission>
        }
      />

      <Route
        path="settings/country"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/country"]}>
            <CountryMaster />
          </RequirePermission>
        }
      />

      <Route
        path="settings/state"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/state"]}>
            <StateManagement />
          </RequirePermission>
        }
      />

      <Route
        path="settings/district"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/district"]}>
            <District />
          </RequirePermission>
        }
      />

      <Route
        path="settings/taluk"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/taluk"]}>
            <Taluk />
          </RequirePermission>
        }
      />

      <Route
        path="settings/village"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/village"]}>
            <Village />
          </RequirePermission>
        }
      />

      <Route
        path="settings/area"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/area"]}>
            <Area />
          </RequirePermission>
        }
      />

      <Route
        path="settings/user"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/user"]}>
            <UserManagement />
          </RequirePermission>
        }
      />

      <Route
        path="settings/user-subscription"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/user-subscription"]}>
            <UserSubscription />
          </RequirePermission>
        }
      />

      <Route
        path="settings/subscription"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/subscription"]}>
            <Subscription />
          </RequirePermission>
        }
      />
      <Route
  path="settings/subscription/:id/offers"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/subscription"]}>
      <SubscriptionOffers />
    </RequirePermission>
  }
/>

      {/* Property Management */}
      <Route
        path="settings/property-management"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/property-management"]}>
            <PropertyManagement />
          </RequirePermission>
        }
      />

{/* Banner Management */}
<Route
  path="settings/banner-management"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/banner-management"]}>
      <BannerManagement />
    </RequirePermission>
  }
/>

      <Route
        path="settings/property-management/add"
        element={
          <RequirePermission permission={ROUTE_PERMISSIONS["settings/property-management/add"]}>
            <PropertyListingPage />
          </RequirePermission>
        }
      />
<Route
  path="settings/property-management/view/:propertyUuid"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/property-management"]}>
      <PropertyView />
    </RequirePermission>
  }
/>

<Route
  path="settings/property-management/analytics/:propertyUuid"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/property-management"]}>
      <PropertyAnalytics />
    </RequirePermission>
  }
/>

      <Route
        path="settings/report/location"
        element={ <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/location"]}>
            <LocationReport />
          </RequirePermission>}
      />

        <Route
        path="settings/report/verification"
        element={ <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/verification"]}>
            <VerificationReport />
          </RequirePermission>}
      />
      <Route
        path="settings/report/transaction"
        element={ <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/transaction"]}>
            <TransactionReports />
          </RequirePermission>}
      />
          <Route
        path="settings/report/tags"
        element={ <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/tags"]}>
            <TagsReport />
          </RequirePermission>}
      />
      <Route
  path="settings/report/gst"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/gst"]}>
      <GstReport />
    </RequirePermission>
  }
/>

<Route
  path="settings/report/invoice"
  element={
    <RequirePermission permission={ROUTE_PERMISSIONS["settings/report/invoice"]}>
      <InvoiceReport />
    </RequirePermission>
  }
/>

      <Route
      path="settings/help-desk/helpDesk"
      element={
        <RequirePermission permission={ROUTE_PERMISSIONS["settings/help-desk"]}>
          <HelpRequestsTable />
        </RequirePermission>
      }
      />


      {/* <Route path="/403" element={<Page403 />} /> */}
    </Route>
      

      </Routes>
  );
}
